import { TranscribeVideoMeta, TranscribeVideoPayload } from 'types/store/TranscribeVideo';
import { createAsyncReducer } from 'utils/Redux';

import { transcribeVideoActions } from '../actions';

export default createAsyncReducer<TranscribeVideoMeta, TranscribeVideoPayload>(transcribeVideoActions);
